import constantFactory from "@gaoding/constant-factory";

export const {
  PIN_OPEN_TYPE,
  PIN_OPEN_TYPE_LIST,
  PIN_OPEN_TYPE_MAP,
  PIN_OPEN_TYPE_ITEM_MAP,
} = constantFactory("PIN_OPEN_TYPE", [
  {
    key: "BLANK",
    label: "新开窗口",
    value: "blank",
  },
  {
    key: "MODAL",
    label: "当前页面",
    value: "modal",
  },
]);
